import { render } from "./ProductInfo.vue?vue&type=template&id=4ef1e8dd&scoped=true"
import script from "./ProductInfo.vue?vue&type=script&lang=js"
export * from "./ProductInfo.vue?vue&type=script&lang=js"

import "./ProductInfo.vue?vue&type=style&index=0&id=4ef1e8dd&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ef1e8dd"],['__file',"resources/js/modules/product-categorization/components/filter/ProductInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4ef1e8dd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4ef1e8dd', __exports__)) {
    api.reload('4ef1e8dd', __exports__)
  }
  
  module.hot.accept("./ProductInfo.vue?vue&type=template&id=4ef1e8dd&scoped=true", () => {
    api.rerender('4ef1e8dd', render)
  })

}


export default __exports__